<template>
  <!-- , width: fixedHeader ? `calc(100% - ${sidebarOpened ? 256 : 80}px)` : '100%'  -->
  <a-layout-header
    v-if="!headerBarFixed"
    :class="[
      fixedHeader && 'ant-header-fixedHeader',
      sidebarOpened ? 'ant-header-side-opened' : 'ant-header-side-closed',
    ]"
    :style="{ padding: '0' }"
  >
    <div v-if="mode === 'sidemenu'" class="header">
      <a-icon
        v-if="device === 'mobile'"
        class="trigger"
        :type="collapsed ? 'menu-fold' : 'menu-unfold'"
        @click="toggle"
      ></a-icon>
      <a-icon
        v-else
        class="trigger"
        :type="collapsed ? 'menu-unfold' : 'menu-fold'"
        @click="toggle"
      />

      <my-org-menu />
      <user-menu></user-menu>
    </div>
    <div v-else :class="['top-nav-header-index', theme]">
      <div class="header-index-wide">
        <div class="header-index-left">
          <logo class="top-nav-header" :showTitle="false" />
          <s-menu
            v-if="device !== 'mobile'"
            mode="horizontal"
            :menu="menus"
            :theme="theme"
          ></s-menu>
          <a-icon
            v-else
            class="trigger"
            :type="collapsed ? 'menu-fold' : 'menu-unfold'"
            @click="toggle"
          ></a-icon>
        </div>
        <my-org-menu />
        <user-menu class="header-index-right"></user-menu>
      </div>
    </div>
  </a-layout-header>
</template>

<script>
import ALayout from "ant-design-vue/lib/layout";
import UserMenu from "../Tools/UserMenu";
import MyOrgMenu from "../Tools/MyOrgMenu";
import SMenu from "../Menu/";
import Logo from "../Tools/Logo";
import AIcon from "ant-design-vue/lib/icon";
import HeadInfo from "@/components/Tools/HeadInfo";

import { mixin } from "@/utils/mixin.js";

const ALayoutHeader = ALayout.Header;

export default {
  name: "GlobalHeader",
  components: {
    ALayoutHeader,
    UserMenu,
    MyOrgMenu,
    SMenu,
    Logo,
    AIcon,
    HeadInfo,
  },
  mixins: [mixin],
  props: {
    mode: {
      type: String,
      // sidemenu, topmenu
      default: "sidemenu",
    },
    menus: {
      type: Array,
      required: true,
    },
    theme: {
      type: String,
      required: false,
      default: "dark",
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false,
    },
    device: {
      type: String,
      required: false,
      default: "desktop",
    },
  },
  data() {
    return {
      headerBarFixed: false,
      qsLoading: false, //首拨及5天内的预约数量loading
      quantityStatistics: {}, //数量统计
    };
  },
  created() {
    if (this.$auth("workbench_show_firstcall_appointment_block")) {
      this.getQuantityStatistics();
    }
  },
  computed: {
    quantityStatisticsContent() {
      const { quantityStatistics } = this;
      const appointment = quantityStatistics.appointment;
      return `${quantityStatistics.total || 0} | ${
        Array.isArray(appointment)
          ? appointment.length > 0
            ? appointment.join(" | ")
            : "0 | 0 | 0 | 0 | 0"
          : "0 | 0 | 0 | 0 | 0"
      }`;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    //获取首拨及5天内的预约数量
    getQuantityStatistics() {
      getSworkStatistics({ limit: 5 })
        .then((res) => {
          this.quantityStatistics = res;
        })
        .catch((err) => {
          handleErrs(err, "获取首拨及5天内的预约数量失败");
        })
        .finally(() => {
          this.qsLoading = false;
        });
    },
    handleScroll() {
      if (this.autoHideHeader) {
        const scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop;
        if (scrollTop > 100) {
          this.headerBarFixed = true;
        } else {
          this.headerBarFixed = false;
        }
      } else {
        this.headerBarFixed = false;
      }
    },
    toggle() {
      this.$emit("toggle");
    },
  },
};
</script>

<style lang="scss" scoped>
.layout.ant-layout {
  .header {
    display: flex;
    .my-org-wrapper {
      flex: 1;
    }
  }
}
.quantityContent {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Page/GlobalHeader.vue